import React, {useCallback} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {MODE_CREATE, MODE_EDIT} from "../../../codes";
import Editor from "../../../common/Editor";
import ColorBox from "../../../common/ColorBox";
import useCarEditor from "./useCarEditor";
import {AppStaticDropdown} from "../../../common/AppStaticDropdown";
import {Checkbox} from "../../../common/Checkbox";
import useProject from "../../../util/useProject";

const DISTANCES = [
  {value: "km", label: "car_distance_km"}
];

const QUANTITIES = [
  {value: "L", label: "car_quantity_liter"}
];

const CONSOS = [
  {value: "L/100 km", label: "car_conso_L_100_km"}
];

export const CarEditor = () => {
  const {show, t, mode, hideCarEditor, car, editedCar, submit, updateEditedCar} = useCarEditor();

  const {runWithExpiration} = useProject();

  const distances = DISTANCES.map(d => ({value: d.value, label: t(d.label)}));
  const quantities = QUANTITIES.map(d => ({value: d.value, label: t(d.label)}));
  const consos = CONSOS.map(d => ({value: d.value, label: t(d.label)}));

  return <Editor
    show={show}
    title={t(mode === MODE_CREATE ? "car_editor_title_add" : "car_editor_title_edit")}
    onShow={useCallback(() => document.getElementById("car-editor-name").focus(), [])}
    onSubmit={runWithExpiration(submit)}
    onCancel={hideCarEditor}
    submitLabel={t("car_editor_button_save")}
    cancelLabel={t("car_editor_button_cancel")}
  >
    <Form.Group as={Row} className="mb-2" controlId="car-editor-name">
      <Form.Label column sm={3}>{t("car_editor_field_name")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          value={editedCar.name}
          onChange={updateEditedCar("name")}
          maxLength="50"
          isInvalid={editedCar.errors.name}
        />

        <Form.Control.Feedback type="invalid">{t(editedCar.errors.name)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="car-editor-odometer-unit">
      <Form.Label column sm={3}>{t("car_editor_field_odometer_unit")}</Form.Label>
      <Col sm={3}>
        <AppStaticDropdown
          value={editedCar.odometerUnit}
          choices={distances}
          onChange={updateEditedCar("odometerUnit")}
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="car-editor-quantity-unit">
      <Form.Label column sm={3}>{t("car_editor_field_quantity_unit")}</Form.Label>
      <Col sm={3}>
        <AppStaticDropdown
          value={editedCar.quantityUnit}
          choices={quantities}
          onChange={updateEditedCar("quantityUnit")}
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="car-editor-conso-unit">
      <Form.Label column sm={3}>{t("car_editor_field_conso_unit")}</Form.Label>
      <Col sm={3}>
        <AppStaticDropdown
          value={editedCar.consoUnit}
          choices={consos}
          onChange={updateEditedCar("consoUnit")}
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="car-editor-color">
      <Form.Label column sm={3}>{t("car_editor_field_color")}</Form.Label>
      <Col sm={9}>
        <ColorBox value={editedCar.color} onChange={updateEditedCar("color")}/>
      </Col>
    </Form.Group>

    {mode === MODE_EDIT && <>
      <Form.Group as={Row} className="mb-2" controlId="car-editor-default">
        <Form.Label column sm={3}>{t("car_editor_field_default")}</Form.Label>
        <Col sm={9}>
          <Checkbox
            id="car-editor-default"
            checked={editedCar.default}
            onChange={updateEditedCar("default")}
            disabled={car?.default}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-2" controlId="car-editor-active">
        <Form.Label column sm={3}>{t("car_editor_field_active")}</Form.Label>
        <Col sm={9}>
          <Checkbox
            id="car-editor-active"
            checked={editedCar.active}
            onChange={updateEditedCar("active")}
            disabled={editedCar.default}
          />
        </Col>
      </Form.Group>
    </>}
  </Editor>;
};
